import H from '@here/maps-api-for-javascript';
import { getThemeProp } from 'global/variables';
import { isPedestrianRoute } from 'utils/map/MapFeatureFilters';
import { getBiggerBbox } from 'utils/map/MapCalculations';

export const SEGMENTS_AMOUNT = 40;

const animationsColor = getThemeProp('animationsColor');
const animationsWeight = getThemeProp('animationsWeight');

export const getRouteCoordinatesAndBbox = (tour, routeId) =>
  tour.features
    .filter((feature) => feature.properties.routeId === routeId && !isPedestrianRoute(feature))
    .reduce(
      (acc, feature) => ({
        bbox: acc.bbox.length === 0 ? feature.bbox : getBiggerBbox(acc.bbox, feature.bbox),
        coordinates: acc.coordinates.concat(feature.geometry.coordinates),
      }),
      { bbox: [], coordinates: [] },
    );

export function createAnimationPool(tour, display) {
  if (!tour) return [];

  const { selectedTour, routeIds } = display;
  const routes = selectedTour !== undefined ? [selectedTour] : routeIds;

  return routes.flatMap((id) => {
    const { coordinates } = getRouteCoordinatesAndBbox(tour, id);
    if (coordinates.length < 2) return [];
    const laps = Math.max(1, Math.round(coordinates.length / SEGMENTS_AMOUNT));

    return Array.from({ length: laps }).flatMap((_, lap) =>
      animationsColor.map((color) => {
        const lineString = new H.geo.LineString();
        lineString.pushLatLngAlt(0, 0, 0);
        lineString.pushLatLngAlt(0, 0, 0);
        const polyline = new H.map.Polyline(lineString, {
          style: { strokeColor: color, lineWidth: animationsWeight },
        });
        polyline.setVisibility(false);
        polyline._routeId = id;
        polyline._lap = lap;
        return polyline;
      }),
    );
  });
}

export function updateAnimationPool(pool, tour, display, step) {
  if (!tour || !pool.length) return;

  const { selectedTour, routeIds } = display;
  const routes = selectedTour !== undefined ? [selectedTour] : routeIds;

  const poolIndex = routes.reduce((idx, id) => {
    const { coordinates } = getRouteCoordinatesAndBbox(tour, id);
    if (coordinates.length < 2) return idx;
    const laps = Math.max(1, Math.round(coordinates.length / SEGMENTS_AMOUNT));
    const amount = Math.round(coordinates.length / laps);

    return Array.from({ length: laps }).reduce((currentIdx, _lap, lap) =>
      animationsColor.reduce((segIdx, _color, segment) => {
        if (segIdx >= pool.length) return segIdx;
        const polyline = pool[segIdx];
        const start = lap * amount + segment + step;
        const from = coordinates[start];
        const to = coordinates[start + 1];

        if (!from || !to) {
          polyline.setVisibility(false);
        } else {
          const lineString = new H.geo.LineString();
          lineString.pushLatLngAlt(from[1], from[0], 0);
          lineString.pushLatLngAlt(to[1], to[0], 0);
          polyline.setGeometry(lineString);
          polyline.setVisibility(true);
        }
        return segIdx + 1;
      }, currentIdx),
    idx);
  }, 0);

  pool.slice(poolIndex).forEach((p) => p.setVisibility(false));
}
